<template>
    <div class="employee-header">
        <div class="container-fluid">
            <a @click="goBack"  class="d-flex justify-content-end">
            <div class="logo logo-border">
                <img  src="../../assets/img/header/award.png" alt="logo" />
            </div>
        </a>
            <div class="employee-title">صفحة الموظف</div>
            <div class="employee-title-underline"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EmployeeHeader',
    methods: {
    goBack() {
      this.$router.go(-1); // Go back to the previous page
    },
  },
}
</script>
<style lang="">

</style>
